import { render, staticRenderFns } from "./EscapeOut.vue?vue&type=template&id=0070a10c&scoped=true"
import script from "./EscapeOut.vue?vue&type=script&lang=js"
export * from "./EscapeOut.vue?vue&type=script&lang=js"
import style0 from "./EscapeOut.vue?vue&type=style&index=0&id=0070a10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070a10c",
  null
  
)

export default component.exports